// extracted by mini-css-extract-plugin
export var image = "StoryblokSEO-module--image--PHVfa";
export var imageWrapper = "StoryblokSEO-module--imageWrapper--mGb7r";
export var label = "StoryblokSEO-module--label--6sxk1";
export var preamble = "StoryblokSEO-module--preamble--NUNj9";
export var title = "StoryblokSEO-module--title--2a3xW";
export var wrapper = "StoryblokSEO-module--wrapper--wTB3O";